import { useState } from 'react'

const initialVideos = [
  {
    id: 'lofi-radio',
    youtubeId: 'jfKfPfyJRdk',
    title: 'Lofi Hip Hop Radio - Beats to Relax and Study to',
    channel: 'Lofi Girl • 14.2M subscribers',
    description: 'Ambient lofi beats perfect for deep work, coding sessions, and relaxed focus.',
    category: 'Music',
    views: '1.2B views',
    timeAgo: 'Live stream'
  },
  {
    id: 'synthwave-chill',
    youtubeId: '4xDzrJKXOOY',
    title: 'Synthwave Radio - Chill Synth and Retro Wave Beats',
    channel: 'Lofi Synth • 850K subscribers',
    description: 'Nostalgic retro synthwave melodies crafted for late-night programming.',
    category: 'Music',
    views: '24M views',
    timeAgo: 'Streamed live'
  },
  {
    id: 'cyberpunk-ambient',
    youtubeId: 'vkQcpYucT8g',
    title: 'Cyberpunk Ambient Rain - Neon City Soundscape',
    channel: 'Ambient Realms • 320K subscribers',
    description: 'Rainy futuristic cityscape audio atmosphere with subtle synthesizer drones.',
    category: 'Aesthetic',
    views: '4.8M views',
    timeAgo: '6 months ago'
  },
  {
    id: 'creative-coding',
    youtubeId: '3b7FxGz_d_E',
    title: 'Creative Coding with Canvas and Audio Visualizers',
    channel: 'CodeArtistry • 410K subscribers',
    description: 'Step-by-step exploration of WebGL, 2D canvas particle systems, and audio reactivity.',
    category: 'Coding',
    views: '210K views',
    timeAgo: '2 months ago'
  },
  {
    id: 'web-os-tutorial',
    youtubeId: '7wG-3Kj9r3A',
    title: 'Building a Desktop OS Simulator in React from Scratch',
    channel: 'Frontend Masters Guild • 580K subscribers',
    description: 'Architecting multi-window state management, dragging, snapping, and component isolation.',
    category: 'Coding',
    views: '650K views',
    timeAgo: '1 year ago'
  },
  {
    id: 'classic-favorite',
    youtubeId: 'dQw4w9WgXcQ',
    title: 'Rick Astley - Never Gonna Give You Up (Official Music Video)',
    channel: 'Rick Astley • 3.8M subscribers',
    description: 'The legendary music video that powers web culture and surprise easter eggs.',
    category: 'Favorites',
    views: '1.6B views',
    timeAgo: '15 years ago'
  }
]

const categories = ['All', 'Music', 'Coding', 'Aesthetic', 'Favorites']

const YouTubeApp = () => {
  const [videos] = useState(initialVideos)
  const [selectedCategory, setSelectedCategory] = useState('All')
  const [searchQuery, setSearchQuery] = useState('')
  const [activeVideo, setActiveVideo] = useState(null)

  const filteredVideos = videos.filter(video => {
    const matchesCategory = selectedCategory === 'All' || video.category === selectedCategory
    const matchesSearch = video.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          video.channel.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          video.description.toLowerCase().includes(searchQuery.toLowerCase())
    return matchesCategory && matchesSearch
  })

  return (
    <div className="flex flex-col h-full bg-slate-950/40 text-white overflow-hidden">
      {/* Top Search & Navigation Bar */}
      <div className="flex flex-wrap items-center justify-between gap-3 p-3 bg-black/40 border-b border-white/10 flex-shrink-0">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-red-600 flex items-center justify-center text-white">
            <i className="fab fa-youtube text-lg"></i>
          </div>
          <span className="font-bold text-sm tracking-tight hidden sm:inline">YouTube Player</span>
        </div>

        <div className="flex-1 max-w-md mx-2">
          <div className="relative">
            <input
              type="text"
              placeholder="Search videos..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-white/10 border border-white/10 rounded-full px-4 py-1.5 text-xs text-white placeholder-white/40 focus:outline-none focus:ring-1 focus:ring-red-500"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery('')}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white text-xs"
              >
                ✕
              </button>
            )}
          </div>
        </div>

        {activeVideo && (
          <button
            onClick={() => setActiveVideo(null)}
            className="px-3 py-1 bg-white/10 hover:bg-white/20 rounded-lg text-xs font-medium text-white transition-colors flex items-center gap-1.5"
          >
            <i className="fas fa-th-large text-xs"></i>
            <span>Browse All</span>
          </button>
        )}
      </div>

      {/* Main Content Area: Player View or Video Grid */}
      {activeVideo ? (
        <div className="flex-1 flex flex-col p-4 sm:p-6 overflow-y-auto bg-black/20">
          <div className="w-full max-w-4xl mx-auto flex flex-col flex-1">
            {/* Embedded YouTube Player */}
            <div className="aspect-video w-full rounded-2xl overflow-hidden bg-black border border-white/10 shadow-2xl mb-4">
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${activeVideo.youtubeId}?autoplay=1&rel=0`}
                title={activeVideo.title}
                className="w-full h-full border-0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>

            {/* Video Metadata */}
            <div className="bg-white/5 border border-white/10 rounded-xl p-4">
              <h2 className="text-lg font-bold text-white mb-1">{activeVideo.title}</h2>
              <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-white/60 pb-3 border-b border-white/10">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center text-white font-bold text-xs">
                    {activeVideo.channel[0]}
                  </div>
                  <div>
                    <div className="font-semibold text-white">{activeVideo.channel}</div>
                    <div className="text-[10px] text-white/40">{activeVideo.category}</div>
                  </div>
                </div>
                <span>{activeVideo.views} • {activeVideo.timeAgo}</span>
              </div>
              <p className="text-xs text-white/80 mt-3 leading-relaxed">
                {activeVideo.description}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex-1 flex flex-col overflow-hidden p-4 sm:p-6">
          {/* Category Filter Tabs */}
          <div className="flex items-center gap-2 mb-4 overflow-x-auto pb-1 flex-shrink-0">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap transition-colors ${
                  selectedCategory === category
                    ? 'bg-red-600/30 text-red-200 border border-red-500/40'
                    : 'bg-white/5 text-white/70 hover:bg-white/10 hover:text-white'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Video Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 flex-1 overflow-y-auto pr-1">
            {filteredVideos.length === 0 ? (
              <div className="col-span-full flex flex-col items-center justify-center py-16 text-center text-white/40 text-xs">
                <i className="fas fa-video-slash text-3xl mb-2"></i>
                <p>No videos found matching your query</p>
              </div>
            ) : (
              filteredVideos.map((video) => (
                <div
                  key={video.id}
                  onClick={() => setActiveVideo(video)}
                  className="group bg-white/5 hover:bg-white/10 border border-white/10 hover:border-red-500/40 rounded-xl overflow-hidden cursor-pointer transition-all duration-200 flex flex-col"
                >
                  <div className="relative aspect-video bg-black/60 overflow-hidden">
                    <img
                      src={`https://i.ytimg.com/vi/${video.youtubeId}/hqdefault.jpg`}
                      alt={video.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                      <div className="w-10 h-10 rounded-full bg-red-600/90 text-white flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                        <i className="fas fa-play text-xs ml-0.5"></i>
                      </div>
                    </div>
                  </div>

                  <div className="p-3 flex-1 flex flex-col justify-between">
                    <div>
                      <h3 className="text-xs font-bold text-white line-clamp-2 group-hover:text-red-300 transition-colors mb-1">
                        {video.title}
                      </h3>
                      <p className="text-[11px] text-white/60 truncate">{video.channel}</p>
                    </div>
                    <div className="flex items-center justify-between text-[10px] text-white/40 mt-3 pt-2 border-t border-white/5">
                      <span>{video.views}</span>
                      <span className="bg-white/10 px-1.5 py-0.5 rounded">{video.category}</span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default YouTubeApp